<template>
  <div class="news-card">
    <div class="news-img" @click="goToLink">
      <div class="img-mask"></div>
      <picture>
        <source
          class="img-absolute"
          media="(max-width: 767px)"
          :srcset="
            _.get(data, 'mobile_image[0].devices.desktop') ||
              _.get(data, 'cover_image[0].devices.mobile')
          "
        />
        <source
          class="img-absolute"
          media="(max-width: 1023px)"
          :srcset="_.get(data, 'cover_image[0].devices.tablet')"
        />
        <img
          class="img-absolute"
          :src="_.get(data, 'cover_image[0].devices.desktop')"
          alt
        />
      </picture>
    </div>
    <div
      @click="goToLink"
      class="title light pointer font-21 text-overflow-hidden-2"
    >
      {{ _.get(data, "front_title") }}
    </div>
    <div
      v-if="
        _.get(data, 'content.tabs[0].content.tabs[0].content') ||
          _.get(data, 'content.tabs[0].content')
      "
      @click="goToLink"
      class="card-content pointer text-overflow-hidden-2 lh-34"
      v-html="
        _.get(data, 'content.tabs[0].content.tabs[0].content') ||
          _.get(data, 'content.tabs[0].content')
      "
    ></div>
    <router-link
      class="row more flex al-center bold uppercase pointer"
      :to="$store.getters['main/getSingleUrl'](data)"
    >
      {{ $fn.tr("ვიზიტი") }}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7.857"
        height="10"
        viewBox="0 0 7.857 10"
      >
        <path
          id="Icon_material-play-arrow"
          data-name="Icon material-play-arrow"
          d="M12,7.5v10l7.857-5Z"
          transform="translate(-12 -7.5)"
          fill="#4d4d4f"
        />
      </svg>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["data"],
  methods: {
    goToLink() {
      this.$router.push(this.$store.getters["main/getSingleUrl"](this.data));
    }
  }
};
</script>
<style lang="scss">
.news-card {
  .news-img {
    position: relative;
    padding-top: 610px;
    margin-bottom: 34px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      img {
        transform: scale(1.1, 1.1);
      }
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      object-fit: cover;
      transition: 0.3s linear;
      transform-origin: center center;
    }
    @media (max-width: 1599px) {
      padding-top: 442px;
    }
    @media (max-width: 1365px) {
      padding-top: 377px;
    }
    @media (max-width: 1023px) {
      padding-top: 429px;
    }
    @media (max-width: 767px) {
      padding-top: 377px;
      margin-bottom: 21px;
    }
    .img-mask {
      top: 0;
      bottom: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      position: absolute;
      background: rgba(26, 26, 26, 0.3);
    }
  }
  .title {
    margin-bottom: 21px;
    height: 45px;
  }
  .card-content {
    text-align: left;
    margin-bottom: 34px;
    height: 60px;
    p {
      text-align: left !important;
    }
  }
  .more {
    transition: 0.4s ease-in-out;
    color: $black;
    svg {
      margin-left: 10px;
      path {
        transition: 0.4s ease-in-out;
      }
    }
    &:hover {
      color: $red;
      transition: 0.4s ease-in-out;
      svg {
        path {
          fill: $red;
          transition: 0.4s ease-in-out;
        }
      }
    }
  }
}
</style>
